import { useContext } from 'react';

import { SavedFilterSelect } from '@webapp/components/SavedFilterSelect'
import { type SavedFilter } from '@webapp/models/SavedFilter'
import { SaveFilterManagerContext } from '../../SavedFilterManagerContext'

export interface ISavedFilterManagerSelectProps {
  inputId?: string
  onEdit?: () => void
}

export const SavedFilterManagerSelect = ({
  inputId,
  onEdit,
}: ISavedFilterManagerSelectProps) => {
  const {
    collectionId,
    applySavedFilters,
    filterManager,
    selectedSavedFilter,
    setSelectedSavedFilter,
  } = useContext(SaveFilterManagerContext)

  const { filterTags } = filterManager

  const onChange = (value) => {
    setSelectedSavedFilter(value)

    if (!value) return

    const { filters: selectedFilters } = value as SavedFilter<any>

    applySavedFilters(selectedFilters)
  }

  return (
    <SavedFilterSelect
      inputId={inputId}
      defaultOptions={false}
      collection={collectionId}
      filterTags={filterTags}
      value={selectedSavedFilter}
      onChange={onChange}
      onEdit={onEdit}
    />
  )
}
